import React, {useEffect} from "react";

import styled from "styled-components";
import {Elements} from "../../../Styles/Elements";
import useVoiceSocketServer from "../../../Provider/useVoiceSocketServer";
import {PiPhoneDisconnectLight} from "react-icons/pi";
import {MdConnectWithoutContact} from "react-icons/md";
import {BiPhoneCall} from "react-icons/bi";
import useGlobalSettings from "../../../Provider/useGlobalSettings";

const Styles = {
	Grid: styled.div`
		display: grid;
		grid-template-columns: 1fr 200px 100px;
	`,
	Player: styled.div`
		text-align: left;
	`
};

export const VoiceSettings = () => {

	const { user: Me } = useGlobalSettings()
	const { connected, Actions, users, microphoneActive, microphoneMuted } = useVoiceSocketServer();

	// useEffect(() => {
	// 	console.log("connected", connected);
	// }, [connected]);
	// useEffect(() => {
	// 	console.log("users", users, microphoneActive,
	// 		microphoneMuted,);
	// }, [users]);

	const handles = {
		connect: () => {
			Actions.connect();
		},
		disconnect: () => {
			Actions.disconnect()
		},
		microphoneActive: () => {
			void Actions.startMicrophone().then( () => {
				Actions.unmuteMicrophone()
			})
		},
		changeVolume: (user: string, volume: number) => {
			Actions.setUserVolume( user, volume / 100 );
		},
	}

	return <div>

		{
			connected
			? <Elements.Buttons onClick={ handles.disconnect } icon={<PiPhoneDisconnectLight />} variant={"secondary"}>
					Trennen
				</Elements.Buttons>
			: <Elements.Buttons onClick={ handles.connect } icon={<BiPhoneCall />} variant={"secondary"}>
					Verbinden
				</Elements.Buttons>

		}
		<Elements.Buttons onClick={ handles.microphoneActive } icon={<MdConnectWithoutContact />} variant={"secondary"}>
			aktivieren
		</Elements.Buttons>

		<Elements.Frames.Section>
			<Elements.Frames.SectionTitle>Personen im Sprach-Chat</Elements.Frames.SectionTitle>

			{ users.length === 0 && <div>Keine Personen im Sprach-Chat</div> }
			<Styles.Grid>
				{
					users.map((user, index) => <>
						<Styles.Player key={index}>{user.username}</Styles.Player>
						{
							Me.name === user.username
							? <div />
							: <Elements.VolumeSet
								max={100}
								value={ Math.round( user.volume * 100 ) }
							 	onChange={ (value) => handles.changeVolume( user.username, value ) }/>
						}
						<Elements.VolumeIndicator volume={ 100 * Math.pow(user.audioPower / 100, 1.5) } />
					</>)
				}
			</Styles.Grid>
		</Elements.Frames.Section>

	</div>;
};